export default "__VITE_ASSET__BsnbB_fH__"